import packageJSON from '../../../package.json';

const { version } = packageJSON;

const Home = () => {
  return (
    <div>
      v{version}
    </div>
  );
};

export { Home };